import { Megaphone, PiggyBank, Users, Wifi, Expand } from "lucide-react";

const reasons = [
  {
    title: "Giới Thiệu",
    description:
      "Giới thiệu hoạt động kinh doanh của doanh nghiệp đến với khách hàng. Chúng tôi là ai? Chúng tôi làm gì? Vì sao nên chọn sản phẩm/dịch vụ của chúng tôi?",
    icon: Users,
  },
  {
    title: "Mở Rộng",
    description:
      "Mở rộng thương hiệu - lĩnh vực kinh doanh của doanh nghiệp đến mọi miền tổ quốc lẫn quốc tế mà không cần mở mặt bằng hay đại lý tại địa phương đó.",
    icon: Expand,
  },
  {
    title: "Kết Nối",
    description:
      "Kết nối với khách hàng của bạn ở bất cứ đâu, tại bất kỳ thời điểm nào trong ngày (24/7/365) một cách nhanh chóng, tiện lợi và đơn giản.",
    icon: Wifi,
  },
  {
    title: "Quảng Cáo",
    description:
      "Quảng cáo sản phẩm, dịch vụ hay cập nhật thông tin doanh nghiệp một cách nhanh chóng nhất đến với khách hàng cũ và tìm thêm nguồn khách hàng mới dễ dàng.",
    icon: Megaphone,
  },
  {
    title: "Tiết Kiệm",
    description:
      "Tiết kiệm chi phí vận hành, nhân sự và quảng bá so với nhiều hình thức truyền thống nhưng vẫn duy trì được khả năng tiếp cận khách hàng ổn định.",
    icon: PiggyBank,
  },
];

const SectionWebsiteWhy: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fffdfd_0%,#fff7f7_100%)] py-16 sm:py-18 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 opacity-[0.08]">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 25% 30%, rgba(239,68,68,0.22) 0, rgba(239,68,68,0.22) 2px, transparent 3px), linear-gradient(30deg, rgba(220,38,38,0.22) 1px, transparent 1px), linear-gradient(150deg, rgba(220,38,38,0.18) 1px, transparent 1px)",
              backgroundSize: "170px 170px, 170px 170px, 170px 170px",
              backgroundPosition: "0 0, 0 0, 85px 85px",
            }}
          />
        </div>
        <div className="absolute left-[-120px] top-12 h-72 w-72 rounded-full bg-red-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-[-100px] h-80 w-80 rounded-full bg-rose-100/70 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="mx-auto max-w-[920px] text-center">
          <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
            Giá trị website
          </span>
          <h2 className="mt-5 text-[25px] font-semibold leading-[1.2] text-[#d92d20] sm:text-[31px] lg:text-[40px]">
            Tại Sao Bạn Cần Phải Thiết Kế Website
          </h2>
          <p className="mx-auto mt-4 max-w-[820px] text-[14px] leading-7 text-slate-600 sm:text-[15px]">
            Thiết kế website là yếu tố cần và quan trọng để doanh nghiệp gia tăng thế mạnh cạnh tranh và
            tiếp cận được nhiều nguồn khách hàng tiềm năng hơn trên Internet.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-[1080px] gap-4 md:grid-cols-2 xl:grid-cols-3">
          {reasons.map(({ title, description, icon: Icon }, index) => {
            const centeredCard = index >= 3 ? "xl:col-span-1" : "";
            const twoItemRow =
              index === 3 ? "xl:col-start-1 xl:translate-x-[190px]" : index === 4 ? "xl:col-start-2 xl:translate-x-[190px]" : "";

            return (
              <article
                key={title}
                className={`rounded-[22px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff9f9_100%)] p-5 text-left shadow-[0_16px_32px_rgba(127,29,29,0.06)] ${centeredCard} ${twoItemRow}`}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff5a47_0%,#dc2626_100%)] text-white shadow-[0_8px_20px_rgba(220,38,38,0.18)]">
                  <Icon size={21} />
                </div>

                <h3 className="mt-4 text-[17px] font-semibold leading-6 text-[#2f1a1a] sm:text-[18px]">{title}</h3>
                <p className="mt-3 text-[13.5px] leading-7 text-slate-600">{description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteWhy;
